export const REPEAT_CONTACT_ROUTE_TO_RING_GROUP = 1
export const REPEAT_CONTACT_ROUTE_TO_OWNER = 2
export const REPEAT_CONTACT_ROUTE_TO_PREVIOUS_USER = 3
export const REPEAT_CONTACT_ROUTE_TO_OWNER_ONLY = 4
export const REPEAT_CONTACT_ROUTE_TO_OWNER_ONLY_STRICT = 5
export const REPEAT_CONTACT_ROUTE_TO_PREVIOUS_USER_ONLY = 6
